/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RollupEdge
 */
export interface RollupEdge {
    /**
     * 
     * @type {string}
     * @memberof RollupEdge
     */
    parentInitiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RollupEdge
     */
    childInitiativeId?: string;
    /**
     * 
     * @type {number}
     * @memberof RollupEdge
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof RollupEdge
     */
    rationale?: string;
    /**
     * 
     * @type {Date}
     * @memberof RollupEdge
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the RollupEdge interface.
 */
export function instanceOfRollupEdge(value: object): value is RollupEdge {
    return true;
}

export function RollupEdgeFromJSON(json: any): RollupEdge {
    return RollupEdgeFromJSONTyped(json, false);
}

export function RollupEdgeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RollupEdge {
    if (json == null) {
        return json;
    }
    return {
        
        'parentInitiativeId': json['parentInitiativeId'] == null ? undefined : json['parentInitiativeId'],
        'childInitiativeId': json['childInitiativeId'] == null ? undefined : json['childInitiativeId'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'rationale': json['rationale'] == null ? undefined : json['rationale'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function RollupEdgeToJSON(json: any): RollupEdge {
    return RollupEdgeToJSONTyped(json, false);
}

export function RollupEdgeToJSONTyped(value?: RollupEdge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parentInitiativeId': value['parentInitiativeId'],
        'childInitiativeId': value['childInitiativeId'],
        'weight': value['weight'],
        'rationale': value['rationale'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

